import { PiniaVuePlugin } from 'pinia';
import Vue from 'vue';
import { i18n } from '@/i18n';
import '@/i18n/vendors';
import { pinia } from '@/pinia';
import App from './App.vue';
// Styles: SCSS
import './assets/scss/main.scss';
// Tailwind
import '@/assets/css/main.css';
// Vue Router
import router from './router';
// design tokens
import '@kolesa-group/design-tokens/index.css';

Vue.use(PiniaVuePlugin);

Vue.config.productionTip = false;

new Vue({
    i18n,
    pinia,
    render: h => h(App),
    router,
}).$mount('#app');
